import { useState, useEffect, useCallback } from 'react';
import { motion } from 'framer-motion';
import { TrendingUp } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TrendingKeywords = ({ topicId }) => {
  const [keywords, setKeywords] = useState([]);

  const fetchTrending = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/trending/${topicId}`);
      setKeywords(response.data.keywords || []);
    } catch { /* trending is non-critical */ }
  }, [topicId]);

  useEffect(() => {
    if (topicId) fetchTrending();
  }, [topicId, fetchTrending]);

  if (keywords.length === 0) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className="mb-6"
      data-testid="trending-section"
    >
      <div className="flex items-center gap-2 mb-3">
        <TrendingUp className="w-4 h-4 text-vent-primary" />
        <span className="text-zinc-500 text-xs font-heading font-bold tracking-wider uppercase">Trending</span>
      </div>
      <div className="flex flex-wrap gap-2">
        {keywords.map((keyword, idx) => (
          <motion.span
            key={keyword}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: idx * 0.08 }}
            className="px-3 py-1.5 bg-vent-primary/10 border border-vent-primary/20 rounded-full text-xs text-vent-primary font-medium"
            data-testid={`trending-tag-${idx}`}
          >
            #{keyword}
          </motion.span>
        ))}
      </div>
    </motion.div>
  );
};

export default TrendingKeywords;
